import React from "react";
import SecondCard from "./SecondCard";
import FirstCard from "./FirstCard";
import ThirdCard from "./ThirdCard";
const ResultAnalysis = ({result}) => {
  return (
    <div
      style={{
        display: "flex",
        columnGap: "1rem",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
        paddingLeft:"3.5rem",paddingRight:"3.5rem"
      }}
    >
      {/* <div className="frame">
      <div className="overlap">
        <div className="div-wrapper">
          <div className="text-wrapper">Marks</div>
        </div>
        <div className="div">80</div>
        <img className="line" alt="Line" src="https://c.animaapp.com/IIutAdkk/img/line-10.svg" />
      </div>
      <div className="text-wrapper-2">100</div>
      <div className="overlap-group">
        <div className="div-wrapper-2">
          <div className="text-wrapper-3">Topper score - 96</div>
        </div>
        <div className="div-2">
          <img
            className="streamline-smiley"
            alt="Streamline smiley"
            src="https://c.animaapp.com/IIutAdkk/img/streamline-smiley-happy-solid.svg"
          />
          <p className="great-job-you-are">
            <span className="span">Great Job!</span>
            <span className="text-wrapper-4">
              {" "}
              you are only 16 marks <br />
              behind the topper. Keep working hard
            </span>
          </p>
        </div>
      </div>
    </div> */}
      <FirstCard result={result}/>
      <SecondCard result={result}/>
      <ThirdCard result={result} />
    </div>
  );
};

export default ResultAnalysis;
